import { PaymentErrorShortCodes } from '../Interfaces/index.js';
import { PaymentValidationError } from '../Errors/index.js';
var BillingMethodACH = /** @class */ (function () {
    function BillingMethodACH(achInfo) {
        this.bankAccountNumber = BillingMethodACH.formatBankAccountNumber(achInfo.bankAccountNumber);
        this.bankRoutingNumber = BillingMethodACH.formatBankRoutingNumber(achInfo.bankRoutingNumber);
        this.accountHolderName = achInfo.accountHolderName;
        this.bankName = achInfo.bankName;
        this.branchCode = achInfo.branchCode;
        this.checkDigit = achInfo.checkDigit;
        this.countryCode = achInfo.countryCode;
    }
    BillingMethodACH.formatBankAccountNumber = function (bankAccountNumber) {
        BillingMethodACH.isValidBankAccountNumber(bankAccountNumber);
        return bankAccountNumber;
    };
    BillingMethodACH.isValidBankAccountNumber = function (bankAccountNumber) {
        if (!/^\d{4,17}$/.test(bankAccountNumber)) {
            throw new PaymentValidationError('Bank account number contains illegal characters or has illegal format. Only numbers are allowed', PaymentErrorShortCodes.invalid_bank_account_number);
        }
        return true;
    };
    BillingMethodACH.formatBankRoutingNumber = function (bankRoutingNumber) {
        BillingMethodACH.isValidBankRoutingNumber(bankRoutingNumber);
        return bankRoutingNumber;
    };
    BillingMethodACH.isValidBankRoutingNumber = function (bankRoutingNumber) {
        if (!/^\d{6,9}$/.test(bankRoutingNumber)) {
            throw new PaymentValidationError('Bank routing number contains illegal characters or has illegal format. Only numbers are allowed', PaymentErrorShortCodes.invalid_bank_routing_number);
        }
        return true;
    };
    return BillingMethodACH;
}());
export { BillingMethodACH };
